module.exports = __webpack_public_path__ + "static/img/transforma-tu-aventura-2.697c166.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/transforma-tu-aventura-2.jpg
// module id = jyrx
// module chunks = 1